import constants from "../constants";
function setGameState(gameState) {
  return function (dispatch) {
    dispatch({
      type: gameState,
    });
  };
}
function setLoadingState(loadingState) {
  return function (dispatch) {
    dispatch({
      type: constants.SET_LOADING_STATE,
      payload: {
        loadingState: loadingState,
      },
    });
  };
}
export { setGameState, setLoadingState };
